import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinner} from '@angular/material/progress-spinner';
import { MatDialog } from '@angular/material/dialog';
import { AlertifyService } from 'src/app/services/alertify.service';
import { HorarioService } from 'src/app/services/horario.service';
import { horarioLst } from 'src/app/models/horarioLst';
import { DisciplinaService } from 'src/app/services/disciplina.service';
import { EmpresaService } from 'src/app/services/empresa.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { CreateEditHorarioComponent } from '../create-edit-horario/create-edit-horario.component';

@Component({
  selector: 'app-index-horario-admin',
  templateUrl: './index-horario-admin.component.html',
  styleUrls: ['./index-horario-admin.component.scss'],
})
export class IndexHorarioAdminComponent implements OnInit {
  public dataSource: any;
  public displayedColumns: string[];
  public isLoadingResults = false;
  public lstDisciplinas: any;
  public lstClubes: any;
  public disciplinaSelect: any;
  public piscinaSelect=-1;
  public clubSelect: any;
  pageIndex: number = 0;
  pageSize: number = 100;
  length: number;
  searchString: string = '';

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public horarioSvc: HorarioService,
    public disciplinaSvc: DisciplinaService,
    public empresaSvc: EmpresaService,
    public dialog: MatDialog,
    private alertify: AlertifyService
  ) {
    let ELEMENT_DATA: horarioLst[] = [];
    this.displayedColumns = [
      'empresa',
      'nombre',      
      'disciplina',
      'piscina',
      'dias',
      'horaInicio',
      'horaFin',
      'habilitado',
      'botones'
    ];

    this.dataSource = new MatTableDataSource<horarioLst>(ELEMENT_DATA);
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.getHorarios(0, 100);
    this.disciplinaSvc.getDisciplinasDropdown().subscribe((disLst) => {
      console.log(disLst);
      this.lstDisciplinas = disLst;
    });
    this.empresaSvc.getEmpresasDropdown().subscribe((clubLst) => {
      console.log(clubLst);
      this.lstClubes = clubLst;
    });
  }

  ngOnInit(): void {}

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getHorarios(page: number, numReg: number) {
    this.isLoadingResults = true;
    this.horarioSvc
      .getHorariosAdmin(
        page,
        numReg,
        this.searchString,
        this.clubSelect,
        this.piscinaSelect,
        this.disciplinaSelect,
      )
      .subscribe((result) => {
        this.dataSource = new MatTableDataSource<horarioLst>(result[0]);
        this.pageIndex = page;
        this.pageSize = numReg;
        this.length = result[1];
        this.isLoadingResults = false;
        console.log('resultado: ', result);
        //this.displayedColumns = ['id', 'nombre', 'email', 'documento'];
      });
  }

  getServerData(event: PageEvent) {
    console.log('click evento paginator', event);
    this.getHorarios(event.pageIndex, event.pageSize);
  }

  onEnter() {
    console.log('boton enter');
    this.getHorarios(0, 100);
  }

  cambioDiscipinaBuscar() {
    this.getHorarios(this.pageIndex, this.pageSize);
  }

  cambioClubBuscar(){
    this.getHorarios(this.pageIndex, this.pageSize);
  }

  cambioPiscinaBuscar(){
    this.getHorarios(this.pageIndex, this.pageSize);
  }

  openDialogCreate(): void {
    let dialogRef = this.dialog.open(CreateEditHorarioComponent, {
    data: null,
  });
  dialogRef.afterClosed().subscribe((result:any) => {
    console.log('dialogo cerrado: ');
    console.log(result);
    console.log(result=='false');
    if (result == 'false') {
      console.log('dialogo cerrado - no actualiza');
    } else {
      console.log('dialogo cerrado - SI actualiza por creacion');
      this.getHorarios(this.pageIndex, this.pageSize);
    }
  });  
}

  
  onToggle(ob: MatSlideToggleChange, elemento: any) {
    console.log(ob.checked);
    console.log(elemento);

    this.horarioSvc
      .updateEstadoHorario(elemento.id,  ob.checked)
      .subscribe((result) => {
        if (result) {
          elemento.estado = ob.checked;
          this.alertify.success('Horario actualizado')
        } else {
          this.alertify.error('Error al actualizar el horario')
          console.log('error al cambiar de estado');
        }
      });
  }
  
  edit(obj: any) {
    console.log(obj);

    let dialogRef = this.dialog.open(CreateEditHorarioComponent, {
      data: obj,
    });
    dialogRef.afterClosed().subscribe((result:any) => {
      console.log('dialogo cerrado: ');
      console.log(result);
      console.log(result=='false');
      if (result == 'false') {
        console.log('dialogo cerrado - no actualiza');
      } else {
        console.log('dialogo cerrado - SI actualiza por edicion');
        this.getHorarios(this.pageIndex, this.pageSize);
      }
    });  
  }

  delete(obj: any) {
    console.log(obj);
    this.alertify.confirm('Confirma que quiere eliminar el horario?', () => {
      this.horarioSvc.deleteHorario(obj.id).subscribe((res) => {
        if (res) {
          this.getHorarios(this.pageIndex, this.pageSize);
          this.alertify.success('Hoario eliminado.');
        } else {
          this.alertify.error('El horario no se ha podido eliminar.');
        }
      });
    });
  }

 
}
